import { render, staticRenderFns } from "./ForestCard.vue?vue&type=template&id=4c4b99af&scoped=true&"
import script from "./ForestCard.vue?vue&type=script&lang=js&"
export * from "./ForestCard.vue?vue&type=script&lang=js&"
import style0 from "./ForestCard.vue?vue&type=style&index=0&id=4c4b99af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b99af",
  null
  
)

export default component.exports